module.exports = __webpack_public_path__ + "3103181a232071d3eb4eb38a81f4c439.svg";